import { useSelector } from 'react-redux'

import { selectPrimerPayPalEnabled } from 'root-redux/selects/common'
import { selectUserCountryCode } from 'root-redux/selects/user'

import { isPayPalAvailableByCountry } from 'helpers/isPayPalAvailableByCountry'

export const useIsPrimerPayPalEnabled = () => {
  const countryCode = useSelector(selectUserCountryCode)
  const isPrimerPayPalEnabled = useSelector(selectPrimerPayPalEnabled)

  const hasPaypalByCountry = isPayPalAvailableByCountry(
    countryCode.toUpperCase(),
  )

  return hasPaypalByCountry && isPrimerPayPalEnabled
}
